// GuestRegisterTemplateコンポーネントをインポート
// ゲスト登録ページ用のテンプレートとして使用
import GuestRegisterTemplate from "../templates/GuestRegisterTemplate";

/** 
 * GuestRegisterPageコンポーネント
 * ゲストユーザー向けの「登録ページ」を表示するためのコンポーネント
 * GuestRegisterTemplateを利用して、登録画面を構築
 */
const GuestRegisterPage = () => {

    // ゲスト登録ページテンプレートをレンダリング
    // 特にプロパティを渡さず、GuestRegisterTemplateをそのまま利用
    return (
        <GuestRegisterTemplate />
    );
}

// GuestRegisterPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default GuestRegisterPage;
